import {useSelector} from "react-redux";
import {skillsSelecror} from "../../Selectors";
import {Skill} from "./Skill";
import React from "react";


export const Skills = React.memo(() => {

    const skills = useSelector(skillsSelecror)

    return <section className={'skills'}>
        <div className="container">
            <div className="skills_inner">
                <div className="skills_title title">
                    <h1>навыки</h1>
                    <h2>навыки</h2>
                </div>
                <div className="skills_items">
                    {skills.map((skill,idx) => {
                        return <Skill key={idx} item={skill}/>
                    })}
                </div>
            </div>
        </div>
    </section>
})